import { useParams } from "react-router-dom";
import { RunEnginePresetContainer } from "./container";

export const RunEnginePresetPane = () => {
  const params = useParams();
  const { id } = params;
  return id ? <RunEnginePresetContainer presetId={id} /> : <></>;
};
